import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInput, MatLabel } from '@angular/material/input';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SiModalModule } from '../si-modal';
import { ValidationService } from '../../services/validation.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { User } from '../../../core/models';
import { Router } from '@angular/router';
import { AccountService, CommonUtilService } from '../../services';
import { AuthenticationService, UserService } from '../../../core/services';
import { MatFormFieldModule } from '@angular/material/form-field';

@UntilDestroy()
@Component({
  templateUrl: './impersonate.component.html',
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    SiModalModule,
  ],
})
export class ImpersonateComponent {
  isImpersonate: boolean = false;
  isimpersonateHaveValue: boolean = false;
  impersonateForm: FormGroup;

  readonly user$: Observable<User>  = this.userService.getUserData();

  constructor(
    public readonly router: Router,
    public readonly commonUtilService: CommonUtilService,
    private readonly authenticationService: AuthenticationService,
    private readonly formBuilder: FormBuilder,
    private readonly userService: UserService,
    readonly accountService: AccountService,
  ) {
  }


}
